import AmatPage from "@/amat/AmatPage";
import VisitsPage from "@/amat/VisitsPage";
import "@/amat/amat.css";

export default function App() {
  return window.location.pathname.replace(/\/$/, "") === "/proposal-visits" ? <VisitsPage /> : <AmatPage />;
}
